/** @jsx jsx */

import { Forms } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

import TableBody from './TableBody';
import {
  IntegrationType,
  onDeleteCallback,
  onEditCallback,
  onViewCallback,
} from './types';

const Styles = {
  root: css`
    border: ${Forms.field.border};
    border-collapse: collapse;
    border-radius: 3px;
    margin: 16px 0 0 0;
  `,
  headerRow: css`
    border-bottom: ${Forms.field.border};
    text-transform: uppercase;
  `,
  headerCell: (
    { isStatus = false }: { isStatus?: boolean } = { isStatus: false }
  ) => [
    css`
      line-height: 1.5;
      padding: 8px 15px;
      font-weight: 600;
      font-size: 13px;
    `,
    isStatus &&
      css`
        white-space: nowrap;
        width: 110px;
      `,
  ],
};

type Props = {
  integrations: Array<IntegrationType>;
  onDelete: onDeleteCallback;
  onEdit: onEditCallback;
  onView: onViewCallback;
};

function Table({ integrations, onDelete, onEdit, onView }: Props) {
  return (
    <table css={Styles.root}>
      <thead>
        <tr css={Styles.headerRow}>
          <th css={Styles.headerCell()}>Name</th>
          <th css={Styles.headerCell()}>Version</th>
          <th css={Styles.headerCell({ isStatus: true })}>Status</th>
          <th aria-label="Integration Actions" css={Styles.headerCell()} />
        </tr>
      </thead>
      {integrations.map(itg => (
        <TableBody
          integration={itg}
          key={itg.id}
          onDelete={onDelete}
          onEdit={onEdit}
          onView={onView}
        />
      ))}
    </table>
  );
}

export default Table;
